import React from 'react'
import { useTranslation } from 'react-i18next'
import Checkbox from 'components/Form/Checkbox/Checkbox'
import { convertToStatus, formatExpirationDate, getSubscriptionIcon, isExpired } from '../../utils'

export const ActiveSectionDesktop = ({
    recurringEnabled,
    expirationDate,
    billingCycleValue,
    canControlRecurring,
    onUpdateRecurring,
    isLoading,
}) => {
    const { t } = useTranslation()
    const expired = isExpired(expirationDate)
    const statusIcon = getSubscriptionIcon(recurringEnabled, expired)
    const formattedExpirationDate = formatExpirationDate(billingCycleValue, expirationDate)

    return (
        <div className="subscriptions__state__item-icon-value subscriptions__state__status">
            <img className="payment" src={statusIcon} alt="" />
            <div className="subscriptions__state__status-info">
                <span className="subscriptions__state__item-active-until-value">
                    <p className="subscriptions__status">{convertToStatus(expired, t)}</p>
                    <p className="subscriptions__info is-until">{`${t('Until')} ${formattedExpirationDate}`}</p>
                    {canControlRecurring && (
                        <Checkbox
                            label={t('Auto-renewal')}
                            value={recurringEnabled}
                            onUpdate={onUpdateRecurring}
                            isDisabled={isLoading}
                        />
                    )}
                    {!canControlRecurring && <p className="subscriptions__info">{t('Auto-renewal disabled')}</p>}
                </span>
            </div>
        </div>
    )
}
